// getLivestreamLeaderboard.js
'use strict';
import createCachedSelector from '../resource/createCachedSelector.js';
import getListData from '../selector/getListData.js';
import {
  RANGE_SESSION,
  TOP_LEADERBOARD_USER_LEAST,
  liveStreamSessionLeaderboardCategory,
} from '../resource/liveStreamConstants.js';

const defaultList = [];

/**
 * Select livestream leaderboard by stream id
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} streamId - livestream stream id
 * @param {string} sessionId - livestream stream session id
 * @param {string} range - livestream leaderboard range
 * @param {string} category - livestream leaderboard category
 * @param {number} [maxSize] - max size
 * @param {number} [placeholderLength] - placeholder length
 * @return {array} livestream leaderboard user Ids.
 */
const getLivestreamLeaderboard = createCachedSelector(
  (
    state,
    streamId,
    sessionId,
    range = RANGE_SESSION,
    category = liveStreamSessionLeaderboardCategory.TOTAL
  ) => {
    const selectPath =
      range === RANGE_SESSION
        ? [
            'liveStream',
            streamId,
            'session',
            sessionId,
            'leaderboard',
            category,
          ]
        : ['liveStream', streamId, 'leaderboard', range];
    return getListData(state, selectPath, 'itemIds');
  },
  (state, streamId, sessionId, range, category, maxSize = null) => maxSize,
  (
    state,
    streamId,
    sessionId,
    range,
    category,
    maxSize,
    placeholderLength = TOP_LEADERBOARD_USER_LEAST
  ) => placeholderLength,
  (userIds = defaultList, maxSize, placeholderLength) => {
    if (userIds.length >= placeholderLength) {
      return maxSize !== null ? userIds.slice(0, maxSize) : userIds;
    }
    const placeholders = new Array(placeholderLength).fill(null);
    return [...userIds, ...placeholders].slice(0, placeholderLength);
  }
)(
  (state, streamId, sessionId, range, category, maxSize, placeholderLength) =>
    `${streamId}:${sessionId}:${range}:${category}:${maxSize}:${placeholderLength}`
);

export default getLivestreamLeaderboard;
